import { creatorsData } from './creatorsData';
const defaultBarDescription = 'From setting up your shop to driving sales, this guide covers everything you need to know about launching successfully on Fourthwall.';
const getModalDescription = (directObject = 'creators') => `We've helped thousands of ${directObject} successfully launch their own brands. Here are our top tips specifically for you.`;
export const personasData = {
    default: {
        guidesParameter: undefined,
        recommendation: {
            title: 'The Ultimate Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription('people'),
        },
    },
    youtuber: {
        guidesParameter: 'youtubers',
        recommendation: {
            title: 'Ultimate Launch Guide: A YouTuber’s Path to Success',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'A Guide for YouTubers',
            description: getModalDescription('YouTubers'),
        },
    },
    twitch_streamer: {
        guidesParameter: 'streamers',
        recommendation: {
            title: "Ultimate Launch Guide: A Streamer's Path to Success",
            description: defaultBarDescription,
            ...creatorsData['Phil DeFranco'],
        },
        modal: {
            title: 'A Guide for Streamers',
            description: getModalDescription('streamers'),
        },
    },
    tiktok_creator: {
        guidesParameter: 'tiktokers',
        recommendation: {
            title: "Ultimate Launch Guide: A TikToker's Path to Success",
            description: defaultBarDescription,
            ...creatorsData['Mads Mitch'],
        },
        modal: {
            title: 'A Guide for TikTokers',
            description: getModalDescription('TikTokers'),
        },
    },
    instagram_creator: {
        guidesParameter: 'instagram-creator',
        recommendation: {
            title: 'The Ultimate Launch Guide for Instagram Creators',
            description: defaultBarDescription,
            ...creatorsData['Mads Mitch'],
        },
        modal: {
            title: 'A Guide for Instagram Creators',
            description: getModalDescription(),
        },
    },
    podcaster: {
        guidesParameter: 'podcasters',
        recommendation: {
            title: 'The Ultimate Launch Guide for Podcasters',
            description: defaultBarDescription,
            ...creatorsData['Ben & Emil'],
        },
        modal: {
            title: 'A Guide for Podcasters',
            description: getModalDescription('podcasters'),
        },
    },
    lifestyle___beauty_creator: {
        guidesParameter: 'lifestyle',
        recommendation: {
            title: 'A Customized Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData['Mads Mitch'],
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription(),
        },
    },
    asmr_creator: {
        guidesParameter: 'asmr',
        recommendation: {
            title: 'The Ultimate Launch Guide for ASMR Creators',
            description: defaultBarDescription,
            ...creatorsData.ASMRxBABEE,
        },
        modal: {
            title: 'A Guide for ASMR Creators',
            description: getModalDescription('ASMR creators'),
        },
    },
    comedian: {
        guidesParameter: 'comedy',
        recommendation: {
            title: 'The Ultimate Launch Guide for Comedy Creators',
            description: defaultBarDescription,
            ...creatorsData['Charlotte Dobre'],
        },
        modal: {
            title: 'A Guide for Comedy Creators',
            description: getModalDescription('comedy creators'),
        },
    },
    musician: {
        guidesParameter: 'musicians',
        recommendation: {
            title: "Ultimate Launch Guide: A Musician's Path to Success",
            description: defaultBarDescription,
            ...creatorsData['Harry Mack'],
        },
        modal: {
            title: 'A Guide for Musicians',
            description: getModalDescription('musicians'),
        },
    },
    faith___spirituality: {
        guidesParameter: 'faith-spirituality',
        recommendation: {
            title: 'A Customized Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData['Phil DeFranco'],
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription(),
        },
    },
    zodiac___astrology: {
        guidesParameter: 'zodiac-astrology',
        recommendation: {
            title: 'A Customized Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData['Mads Mitch'],
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription(),
        },
    },
    cultural___travel_creator: {
        guidesParameter: 'culture-travel',
        recommendation: {
            title: 'The Ultimate Launch Guide for Culture & Travel Creators',
            description: defaultBarDescription,
            ...creatorsData['Mads Mitch'],
        },
        modal: {
            title: 'A Guide for Culture & Travel Creators',
            description: getModalDescription(),
        },
    },
    news___politics: {
        guidesParameter: 'news-politics',
        recommendation: {
            title: 'The Ultimate Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData['Phil DeFranco'],
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription(),
        },
    },
    hobby_creator: {
        guidesParameter: 'hobby',
        recommendation: {
            title: 'The Ultimate Launch Guide for Hobby Creators',
            description: defaultBarDescription,
            ...creatorsData['Mads Mitch'],
        },
        modal: {
            title: 'A Guide for Hobby Creators',
            description: getModalDescription(),
        },
    },
    food___mukbang_creator: {
        guidesParameter: 'food-mukbang',
        recommendation: {
            title: 'The Ultimate Launch Guide for Mukbang Creators',
            description: defaultBarDescription,
            ...creatorsData['Paolo fromTOKYO'],
        },
        modal: {
            title: 'A Guide for Mukbang Creators',
            description: getModalDescription(),
        },
    },
    tech_creator: {
        guidesParameter: 'technology',
        recommendation: {
            title: 'The Ultimate Launch Guide for Tech Creators',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'A Guide for Tech Creators',
            description: getModalDescription('tech creators'),
        },
    },
    personal_development_creator: {
        guidesParameter: 'personal-development',
        recommendation: {
            title: 'A Customized Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription(),
        },
    },
    health___fitness: {
        guidesParameter: 'health-fitness',
        recommendation: {
            title: 'The Ultimate Launch Guide for Health & Fitness Creators',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'A Guide for Health & Fitness Creators',
            description: getModalDescription(),
        },
    },
    business___motivation_creator: {
        guidesParameter: 'business-motivation',
        recommendation: {
            title: 'A Customized Launch Guide for You',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'Your Launch Guide',
            description: getModalDescription(),
        },
    },
    true_crime_creator: {
        guidesParameter: 'true-crime',
        recommendation: {
            description: defaultBarDescription,
            title: 'The Ultimate Launch Guide for True Crime Creators',
            ...creatorsData['Ben & Emil'],
        },
        modal: {
            title: 'A Guide for True Crime Creators',
            description: getModalDescription('true crime creators'),
        },
    },
    sports_creator: {
        guidesParameter: 'sports',
        recommendation: {
            title: 'The Ultimate Launch Guide for Sports Creators',
            description: defaultBarDescription,
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'A Guide for Sports Creators',
            description: getModalDescription('sports creators'),
        },
    },
    historian: {
        guidesParameter: 'history',
        recommendation: {
            description: defaultBarDescription,
            title: 'The Ultimate Launch Guide for History Creators',
            ...creatorsData['Armchair Historian'],
        },
        modal: {
            title: 'A Guide for History Creators',
            description: getModalDescription('history creators'),
        },
    },
    gamer: {
        guidesParameter: 'gaming',
        recommendation: {
            description: defaultBarDescription,
            title: 'The Ultimate Launch Guide for Gaming Creators',
            ...creatorsData.MKBHD,
        },
        modal: {
            title: 'A Guide for Gaming Creators',
            description: getModalDescription(),
        },
    },
    entertainer: {
        guidesParameter: 'entertainment',
        recommendation: {
            description: defaultBarDescription,
            title: 'The Ultimate Launch Guide for Entertainment Creators',
            ...creatorsData['Charlotte Dobre'],
        },
        modal: {
            title: 'A Guide for Entertainment Creators',
            description: getModalDescription(),
        },
    },
};
